declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackRegisterClick(source: string, label?: string) {
  window.gtag?.("event", "register_click", {
    click_source: source,
    click_label: label ?? source,
  });
}
